import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Editor from '@monaco-editor/react';
import { CheckCircle, XCircle } from 'lucide-react';

export default function ChallengeResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const { code, challenge, passed } = location.state || {};

  const solution = `using System;

public class Solution {
    public static int ArraySum(int[] numbers) {
        if (numbers == null || numbers.Length == 0)
            return 0;
            
        int sum = 0;
        foreach (int num in numbers)
            sum += num;
            
        return sum;
    }
}`;

  if (!challenge) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 py-12 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">No Result Found</h1>
          <button
            onClick={() => navigate('/coding-challenge')}
            className="bg-purple-600 text-white px-6 py-2 rounded-lg"
          >
            Back to Challenges
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-bold text-gray-800">{challenge.title} - Result</h1>
            {passed ? (
              <div className="flex items-center text-green-600">
                <CheckCircle className="w-6 h-6 mr-2" />
                <span className="font-semibold">Passed</span>
              </div>
            ) : (
              <div className="flex items-center text-red-600">
                <XCircle className="w-6 h-6 mr-2" />
                <span className="font-semibold">Failed</span>
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold mb-4">Your Solution</h3>
              <div className="h-[400px] border rounded-lg overflow-hidden">
                <Editor
                  height="100%"
                  defaultLanguage="csharp"
                  theme="vs-light"
                  value={code}
                  options={{
                    minimap: { enabled: false },
                    fontSize: 14,
                    readOnly: true
                  }}
                />
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Sample Solution</h3>
              <div className="h-[400px] border rounded-lg overflow-hidden">
                <Editor
                  height="100%"
                  defaultLanguage="csharp"
                  theme="vs-light"
                  value={solution}
                  options={{
                    minimap: { enabled: false },
                    fontSize: 14,
                    readOnly: true
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-4">
          <button
            onClick={() => navigate('/coding-challenge')}
            className="bg-gray-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-700 transition-colors"
          >
            Try Another Challenge
          </button>
          <button
            onClick={() => navigate('/')}
            className="bg-purple-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}